export default "/_next/static/73abc27b4ee77bea4a8bd32d2f9103e8.svg";